(function () {
    'use strict';

    var module = angular.module('app.directives');
    module.directive('longDataTranslateCollapser', ['$filter', 'config', function ($filter, config) {
        var directive = {
            restrict: 'E',
            replace: false,
            templateUrl: config.clientAppSrcPath + 'app/directives/longDataTranslateCollapser/longDataTranslateCollapser.html',
            link: link,
            scope: {
                translateName: '=',
                maxLenght: '='
            }
        };

        return directive;

        function link(scope, element, attrs) {
            scope.translatedText = $filter('translate')(scope.translateName);

            if (scope.translatedText.length > scope.maxLenght) {
                scope.isTooLong = true;
                scope.isCollapsed = true;
            }
        }
    }]);
})();